module.exports = __webpack_public_path__ + "static/img/footer_join.70b6a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer_join.png
// module id = f836
// module chunks = 1